import React from "react";
import { Container, Row, Col } from "react-bootstrap";
// import myImg from "../../Assets/Bg-screen/avatar2.svg";
import myImg from "../../Assets/avatar.svg";

import Tilt from "react-parallax-tilt";

import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
 
} from "react-icons/ai";
import { FaLinkedinIn, FaWhatsapp } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I fell in love with programming and I have at least learnt
              something, I think… 🤷‍♂️
              <br />
              <br />I am fluent in classics like
              <i>
                <b className="purple"> C++, Javascript and React.js . </b>
              </i>
              <br />
              <br />
              My field of Interest's are building new &nbsp;
              <i>
                <b className="purple">Web Technologies and Products </b> and
                also in areas related to{" "}
                <b className="purple">
                  Cloud computing and game development.
                </b>
              </i>
              <br />
              <br />
              Whenever possible, I also apply my passion for developing products
              with <b className="purple">Node.js</b> and
              <i>
                <b className="purple">
                  {" "}
                  Modern Javascript Library and Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js and Next.js</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links" style={{marginBottom:"100px"}}>
              <li className="social-icons">
                <a
                  href="https://github.com/Harshdubey1198"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
                <h6 style={{color:"white"}}>Github</h6>

              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/officialharsh02"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                > <AiOutlineTwitter />
                </a>
               <h6 style={{color:"white"}}>Twitter</h6>

              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/harshdubey1198"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
                <h6 style={{color:"white"}}>LinkedIn</h6>
              </li>
              <li className="social-icons">
                <a
                  href="https://instagram.com/its_harsh_1198?igshid=ZDdkNTZiNTM="
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
                <h6 style={{color:"white"}}>Instagram</h6>

              </li>
              <li className="social-icons">
                <a
                  href="https://api.whatsapp.com/send/?phone=%2B919691495822&text&type=phone_number&app_absent=0"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaWhatsapp />
                </a>
                <h6 style={{color:"white"}}>Whatsapp</h6> 
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
